module.exports = __webpack_public_path__ + "static/media/Sony W850C.1a80c679.png";